import './link_inactive_pending_approval_modal.less';

import React from 'react';

import SimpleModalWithHeader from 'zoomforth_component_lib/simple_modal_with_header.jsx';


const PendingApprovalModal = ({
  onRequestClose
})=>
  <SimpleModalWithHeader
    title="Link Successfully Created"
    subtitle={'Your site is still pending approval.'}
    className="modal-page-initial-approval-request"
    onRequestClose={onRequestClose}
  >

    <div className="page-approval-requested">
      Your site will be reviewed by an account administrator.<br/><br/>
      Until your new site is approved, the link you just made will not be active.
      You will receive an email once this page has been approved.
    </div>
  </SimpleModalWithHeader>;

export default PendingApprovalModal;